import BigNumber from "bignumber.js";
import { Keypair } from '@solana/web3.js';

const l = console.log
export const log = (...datas) => {
    if (process.env.NODE_ENV == "production") return;
    l(...datas)
}
if (process.env.NODE_ENV == "production") {
    console.log = log;
}


//extend BigNumber
BigNumber.prototype.toTrimed = function (minDecimal = 0, maxDecimal) {
    const str = this.toFixed(maxDecimal);
    return trimZero(str, minDecimal);
}

/**
 * 输出货币金额
 * 如果货币金额>1，小数位数按照minDecimal执行
 * 如果货币金额<1，小数位数按照maxDecimal执行
 */
BigNumber.prototype.toCurrencyFixed = function (minDecimal = 2, maxDecimal = 6) {
    const one = new BigNumber(1);
    if (one.isGreaterThan(this)) {
        //<1
        return this.toTrimed(minDecimal, maxDecimal);
    } else {
        return this.toTrimed(minDecimal, minDecimal);
    }
}


const padEndZero = (str, length) => {
    if (length == 0) {
        return str;
    }
    const dot = str.indexOf('.');
    let decimal = 0;
    if (dot >= 0) {
        decimal = str.length - dot;
    }

    if (decimal >= length) {
        return str;
    } else {
        let pad = ''.padEnd(length - decimal, '0');
        if (dot == -1) pad = '.' + pad;
        return str + pad;
    }

}

const trimZero = (str, decimal = 0) => {
    const dot = str.indexOf('.');
    let trimFrom = -1;
    if (dot >= 0) {
        for (let i = str.length - 1; i >= dot; i--) {
            const n = str[i];
            if (n == '0') {
                trimFrom = i;
            } else {
                break;
            }
        }
    }

    if (trimFrom != -1) {
        if (trimFrom - 1 == dot) {
            //后面全是0
            return padEndZero(str.slice(0, trimFrom - 1), decimal);
        } else {
            return padEndZero(str.slice(0, trimFrom), decimal);
        }
    } else {
        return padEndZero(str, decimal);
    }
}



//extend Keypair
Keypair.prototype.address = function () {
    return this.publicKey.toBase58();
}